import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from './StrengthsAndWeaknesses.styles';
import { EStatisticType } from '../../constans/report';
import { IStrengthsAndWeaknessesData } from '../../services/reports';
import StatisticsBox from '../Statistics/StatisticsBox/StatisticsBox';

interface IStrengthsAndWeaknesses {
  data: IStrengthsAndWeaknessesData;
}

const StrengthsAndWeaknesses: FC<IStrengthsAndWeaknesses> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Container id="Container">
      <StatisticsBox
        noDataText={t('report.topicsStats.noStrengthsTopics')}
        name={t('report.topicsStats.strengths')}
        columnName={t('report.topicsStats.teams')}
        description={data?.strengths?.description || ''}
        results={data?.strengths?.strengthResults || []}
        statisticType={EStatisticType.strengthWeaknesses}
      />
      <StatisticsBox
        noDataText={t('report.topicsStats.noWeaknessesTopics')}
        name={t('report.topicsStats.weaknesses')}
        columnName={t('report.topicsStats.teams')}
        description={data?.weaknesses?.description || ''}
        results={data?.weaknesses?.weaknessResults || []}
        statisticType={EStatisticType.strengthWeaknesses}
      />
    </Container>
  );
};

export default StrengthsAndWeaknesses;
